import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerhireforeventspune() {



  const cardData = {
"keyword": "Tempo Traveller Hire for Event Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Tempo Traveller Hire for Event Pune for weddings, corporate events, concerts, exhibitions, family functions, college events, and group transportation requirements. Our fleet includes comfortable 9, 12, 14, 17, 20, and 26-seater tempo travellers equipped with air-conditioning, pushback seats, spacious interiors, luggage space, and experienced drivers familiar with Pune city event venues and highway routes. We ensure safe, comfortable, and punctual transportation with doorstep pickup for local and outstation event travel across Pune.",

"topPlaces": [
  {
    "title": "Balewadi High Street",
    "description":
      "Balewadi High Street is a popular commercial and entertainment destination in Pune known for corporate events, restaurants, and nightlife."
  },
  {
    "title": "Shaniwar Wada",
    "description":
      "Shaniwar Wada is a historic venue in Pune frequently visited during cultural programs and city sightseeing events."
  },
  {
    "title": "Amanora Town Centre",
    "description":
      "Amanora Town Centre is a major shopping and event destination in Pune hosting exhibitions, concerts, and public gatherings."
  },
  {
    "title": "Mahalaxmi Lawns",
    "description":
      "Mahalaxmi Lawns is a popular wedding and event venue in Pune known for large celebrations and group functions."
  },
  {
    "title": "Pune Exhibition Center",
    "description":
      "Pune Exhibition Center in Moshi hosts trade fairs, business expos, exhibitions, and corporate events throughout the year."
  },
  {
    "title": "Magarpatta City",
    "description":
      "Magarpatta City is a major IT and commercial hub in Pune frequently used for corporate events and employee gatherings."
  },
  {
    "title": "Koregaon Park",
    "description":
      "Koregaon Park is a premium Pune locality known for cafes, luxury hotels, parties, and social events."
  },
  {
    "title": "Balewadi Stadium",
    "description":
      "Balewadi Stadium is a major sports and event venue in Pune hosting tournaments, concerts, and large public events."
  },
  {
    "title": "Pune Race Course",
    "description":
      "Pune Race Course is a popular venue for exhibitions, corporate functions, and entertainment events in Pune."
  },
  {
    "title": "Hinjewadi IT Park",
    "description":
      "Hinjewadi IT Park is one of Pune’s largest IT hubs frequently used for corporate meetings, employee events, and business travel."
  }
],



services: [
  {
    name: "Event Tempo Traveller Pune",
    description: "Event tempo traveller Pune service provides dependable transportation for weddings, corporate functions, concerts, exhibitions, family celebrations, and social gatherings. Spacious seating and comfortable interiors ensure smooth journeys suitable for local and outstation event travel requirements. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, offices, hotels, airports, and event venues across Pune. Flexible booking options allow convenient event tempo traveller reservations."
  },
  {
    name: "Wedding Tempo Traveller Pune",
    description: "Wedding tempo traveller Pune service offers stylish transportation for marriage ceremonies, bridal parties, wedding guests, and family travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient wedding tempo traveller reservations."
  },
  {
    name: "Corporate Event Traveller Pune",
    description: "Corporate event traveller Pune service provides professional transportation for office events, conferences, employee outings, seminars, and executive travel requirements. Comfortable seating ensures smooth journeys suitable for corporate passengers and business groups. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, hotels, commercial hubs, and event venues across Pune. Flexible booking options allow convenient corporate event traveller reservations."
  },
  {
    name: "Birthday Event Traveller Pune",
    description: "Birthday event traveller Pune service offers comfortable transportation for birthday celebrations, family gatherings, party events, and social functions. Spacious seating and smooth travel ensure enjoyable journeys suitable for guest transportation and event travel requirements. Professional chauffeurs ensure safe transportation and timely pickup services throughout the itinerary. Pickup services are available from homes, hotels, restaurants, and event venues across Pune. Flexible booking options allow convenient birthday event traveller reservations."
  },
  {
    name: "Party Bus Pune",
    description: "Party bus Pune service provides spacious transportation for celebrations, music events, night outings, birthday parties, and group entertainment travel. Comfortable interiors and smooth highway travel ensure enjoyable journeys suitable for social gatherings and party travel requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, clubs, restaurants, and event venues across Pune. Flexible booking options allow convenient party bus reservations."
  },
  {
    name: "Group Event Transport Pune",
    description: "Group event transport Pune service provides reliable transportation for conferences, weddings, office gatherings, exhibitions, school events, and tourist group travel. Spacious seating ensures comfortable journeys suitable for local and outstation group event transportation. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and event venues across Pune. Flexible booking options allow convenient group event transport reservations."
  },
  {
    name: "AC Tempo Traveller Event Pune",
    description: "AC tempo traveller event Pune service offers premium air-conditioned transportation for weddings, corporate functions, sightseeing events, and family gatherings. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure dependable transportation and safe driving services throughout the journey. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient AC event traveller reservations."
  },
  {
    name: "Luxury Event Traveller Pune",
    description: "Luxury event traveller Pune service provides premium transportation with elegant interiors and spacious seating for weddings, corporate events, VIP travel, and social gatherings. Smooth travel and modern amenities ensure pleasant journeys suitable for executive passengers and event groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from luxury hotels, homes, offices, and event venues across Pune. Flexible booking options allow convenient luxury event traveller reservations."
  },
  {
    name: "17 Seater Event Traveller Pune",
    description: "17 seater event traveller Pune service provides comfortable transportation for weddings, office outings, birthday parties, sightseeing events, and medium-sized group travel. Spacious seating and luggage space ensure smooth journeys suitable for local and outstation event transportation. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and event venues across Pune. Flexible booking options allow convenient 17 seater event traveller reservations."
  },
  {
    name: "20 Seater Event Traveller Pune",
    description: "20 seater event traveller Pune service offers spacious transportation for conferences, family celebrations, office outings, wedding travel, and social gatherings. Comfortable seating ensures smooth journeys suitable for medium-sized passenger groups and event transportation needs. Professional drivers ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient 20 seater event traveller reservations."
  },
  {
    name: "26 Seater Event Traveller Pune",
    description: "26 seater event traveller Pune service provides reliable transportation for corporate gatherings, destination weddings, educational events, sightseeing tours, and family group travel. Spacious seating and luggage capacity ensure comfortable journeys suitable for local and outstation event transportation. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and event venues across Pune. Flexible booking options allow convenient 26 seater event traveller reservations."
  },
  {
    name: "32 Seater Event Traveller Pune",
    description: "32 seater event traveller Pune service provides spacious transportation for conferences, wedding events, school functions, tourist groups, and social gatherings. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for larger passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from offices, homes, hotels, and airports across Pune. Flexible booking options allow convenient 32 seater event traveller reservations."
  },
  {
    name: "Hinjewadi Event Transport Pune",
    description: "Hinjewadi event transport Pune service provides dependable transportation for IT company events, office outings, employee gatherings, conferences, and corporate travel requirements. Comfortable seating ensures smooth journeys suitable for office staff and business passenger groups. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from offices, hotels, and business hubs across Hinjewadi Pune. Flexible booking options allow convenient Hinjewadi event transport reservations."
  },
  {
    name: "Kharadi Event Traveller Pune",
    description: "Kharadi event traveller Pune service offers reliable transportation for office functions, weddings, conferences, airport transfers, and group travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for corporate employees and family groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Kharadi Pune. Flexible booking options allow convenient Kharadi event traveller reservations."
  },
  {
    name: "Baner Event Bus Pune",
    description: "Baner event bus Pune service provides comfortable transportation for family gatherings, office travel, airport pickups, and social events. Spacious seating and luggage space ensure smooth journeys suitable for local and outstation event transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Baner Pune. Flexible booking options allow convenient Baner event bus reservations."
  },
  {
    name: "Wakad Event Traveller Pune",
    description: "Wakad event traveller Pune service provides reliable transportation for office outings, family celebrations, airport transfers, and outstation group travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for business and leisure event travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Wakad Pune. Flexible booking options allow convenient Wakad event traveller reservations."
  },
  {
    name: "Pimpri Chinchwad Event Bus Pune",
    description: "Pimpri Chinchwad event bus Pune service offers dependable transportation for corporate travel, family events, wedding functions, and airport transfers. Spacious seating and luggage capacity ensure smooth journeys suitable for local and outstation passenger movement. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient event bus reservations."
  },
  {
    name: "Airport Event Pickup Pune",
    description: "Airport event pickup Pune service provides dependable transportation for airport transfers, tourist groups, business travelers, wedding guests, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and event venues across Pune. Flexible booking options allow convenient airport event pickup reservations."
  },
  {
    name: "Outstation Event Travel Pune",
    description: "Outstation event travel Pune service provides dependable long-distance transportation for destination weddings, sightseeing trips, conferences, family vacations, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient outstation event travel reservations."
  },
  {
    name: "Pune Event Shuttle Service",
    description: "Pune event shuttle service provides reliable transportation for conferences, exhibitions, office gatherings, weddings, and guest transfer requirements. Comfortable seating and smooth travel ensure pleasant journeys suitable for local event transportation and group movement. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the itinerary. Pickup services are available from hotels, airports, offices, and event venues across Pune. Flexible booking options allow convenient event shuttle service reservations."
  },
  {
    name: "Affordable Event Bus Pune",
    description: "Affordable event bus Pune service provides economical transportation for educational events, family functions, office travel, sightseeing journeys, and local or outstation group trips. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly event transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient affordable event bus reservations."
  },
  {
    name: "Premium Event Transport Pune",
    description: "Premium event transport Pune service offers luxury transportation with spacious interiors and comfortable seating for corporate events, weddings, conferences, and VIP travel requirements. Smooth journeys and modern amenities ensure pleasant travel experiences suitable for executive passengers and event groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from hotels, homes, offices, and airports across Pune. Flexible booking options allow convenient premium event transport reservations."
  },
  {
    name: "Pune Event Booking Vehicle",
    description: "Pune event booking vehicle service provides dependable transportation for weddings, business events, sightseeing tours, concerts, and social gatherings. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation event transportation. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and event venues across Pune. Flexible booking options allow convenient event vehicle reservations."
  },
  {
    name: "Event Group Travel Pune",
    description: "Event group travel Pune service offers spacious transportation for family celebrations, office outings, conferences, educational tours, and social gatherings. Comfortable seating ensures pleasant journeys suitable for medium and large passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient event group travel reservations."
  },
  {
    name: "Corporate Outing Bus Pune",
    description: "Corporate outing bus Pune service provides professional transportation for employee outings, office picnics, conferences, team-building events, and corporate travel requirements. Spacious seating and smooth highway travel ensure pleasant journeys suitable for office staff and executive groups. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, hotels, and business hubs across Pune. Flexible booking options allow convenient corporate outing bus reservations."
  }
],

tableData: [
  ["Event Tempo Traveller Pune", "Wedding Tempo Traveller Pune"],
  ["Corporate Event Traveller Pune", "Birthday Event Traveller Pune"],
  ["Party Bus Pune", "Group Event Transport Pune"],
  ["AC Tempo Traveller Event Pune", "Luxury Event Traveller Pune"],
  ["17 Seater Event Traveller Pune", "20 Seater Event Traveller Pune"],
  ["26 Seater Event Traveller Pune", "32 Seater Event Traveller Pune"],
  ["Hinjewadi Event Transport Pune", "Kharadi Event Traveller Pune"],
  ["Baner Event Bus Pune", "Wakad Event Traveller Pune"],
  ["Pimpri Chinchwad Event Bus Pune", "Airport Event Pickup Pune"],
  ["Outstation Event Travel Pune", "Pune Event Shuttle Service"],
  ["Affordable Event Bus Pune", "Premium Event Transport Pune"],
  ["Pune Event Booking Vehicle", "Event Group Travel Pune"],
  ["Corporate Outing Bus Pune", "Luxury Event Traveller Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller Hire for Event Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller hire service for events in Pune with comfortable vehicles, professional drivers, and smooth transportation arrangements for corporate events, weddings, and group travel."
      },
      {
        WhyChooseheading: "Affordable Event Tempo Traveller Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller hire for events in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Event Transportation Service",
        WhyChoosedescription: "Our Tempo Traveller rental service for events in Pune operates 24 hours for weddings, corporate gatherings, conferences, exhibitions, concerts, airport transfers, and private celebrations."
      },
      {
        WhyChooseheading: "Comfortable AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for comfortable and hassle-free event transportation."
      },
      {
        WhyChooseheading: "Customized Event Travel Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized travel plans for weddings, business meetings, employee transport, family events, social gatherings, and outstation event travel requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, 20 seater, 26 seater, and larger Tempo Travellers suitable for event guests, office teams, tourists, and family groups."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pune Airport, railway stations, hotels, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Smooth Event Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth travel coordination, and timely transportation for all types of local and outstation events."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller hire for events in Pune?", answer: "Tempo Traveller hire for events in Pune provides comfortable group transportation for weddings, corporate events, family functions, conferences, and private gatherings." },
    { question: "Is Tempo Traveller booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller rental service for events in Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, 20 seater, 26 seater, and larger Tempo Travellers for different event transportation requirements." },
    { question: "Can I book Tempo Traveller for wedding guest transportation?", answer: "Yes, customers can book Tempo Travellers for wedding guest pickup, family travel, and event transportation in Pune." },
    { question: "Do you provide Tempo Traveller for corporate events in Pune?", answer: "Yes, Aaradhya Travels provides Tempo Traveller service for office outings, conferences, exhibitions, employee transport, and corporate travel." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Pune?", answer: "Yes, customers can easily book Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide airport pickup and drop service for events?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service for wedding guests, corporate teams, and event attendees." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for event Tempo Traveller service?", answer: "Yes, advance booking is available and recommended during weekends, wedding seasons, festivals, and peak event periods." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Jadhav",
    feedback:
      "For our wedding event in Pune, Aaradhya Travels arranged a Tempo Traveller that made guest transportation very smooth. The vehicle was clean, spacious, and kept everything running on time without any confusion.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "Tempo Traveller hire for our wedding in Pune through Aaradhya Travels was handled very well. Guests traveled comfortably between venues, and the overall coordination made the entire event stress-free.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Hire for Events in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/event-tempo-traveller-pune.jpg",
  "description": "Book Tempo Traveller for events in Pune with Aaradhya Travels for weddings, corporate events, birthdays, parties, and group celebrations. Available 17, 20, 26, and 32 seater AC luxury tempo travellers with professional driver service across Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "10580"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-for-event-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Tempo Traveller Hire for Events in Pune | Wedding & Corporate Transport | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller for events in Pune with Aaradhya Travels. Perfect for weddings, corporate events, birthdays, parties, and group transport with 17 to 32 seater AC luxury travellers across Pune."
  />

  <meta
    name="keywords"
    content="Event tempo traveller Pune, wedding tempo traveller Pune, corporate event traveller Pune, birthday event traveller Pune, party bus Pune, group event transport Pune, AC tempo traveller event Pune, luxury event traveller Pune, 17 seater event traveller Pune, 20 seater event traveller Pune, 26 seater event traveller Pune, 32 seater event traveller Pune, Hinjewadi event transport Pune, Kharadi event traveller Pune, Baner event bus Pune, Wakad event traveller Pune, Pimpri Chinchwad event bus Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerhireforeventspune ;